import clsx from 'clsx'
import type { DetailField } from './types'

export function DetailFields({
  fields,
  cols = 2,
  variant = 'compact',
}: {
  fields: DetailField[]
  cols?: 2 | 3
  variant?: 'compact' | 'list'
}): JSX.Element {
  if (variant === 'list') {
    return (
      <dl className="divide-y divide-slate-200">
        {fields.map((f) => (
          <div
            key={f.label}
            className="flex items-baseline justify-between gap-4 px-6 py-3 hover:bg-slate-50"
          >
            <dt className="text-xs text-slate-500">{f.label}</dt>
            <dd className={clsx('shrink-0 font-mono text-sm tabular-nums text-slate-900', f.tone)}>
              {f.value}
            </dd>
          </div>
        ))}
      </dl>
    )
  }

  return (
    <dl className={cols === 3
      ? 'grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3'
      : 'grid grid-cols-2 gap-x-3 gap-y-1.5'}>
      {fields.map((f) => (
        <div key={f.label} className="flex items-baseline justify-between gap-2">
          <dt className="truncate text-xs text-slate-500">{f.label}</dt>
          <dd className={clsx('min-w-0 truncate text-right font-mono text-xs tabular-nums text-slate-900', f.tone)}>
            {f.value}
          </dd>
        </div>
      ))}
    </dl>
  )
}
